import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Navigate, RouteObject } from 'react-router';

// Layouts
import AuthorizedLayout from '@acorn/portal/src/layouts/AuthorizedLayout';
import UnauthorizedLayout from '@acorn/portal/src/layouts/UnauthorizedLayout';

// Shared Pages
import MTAStartDateCheck from '@acorn-portal/shared/src/components/wrapper/MtaStartDateCheckWrapper';
import ChangePassword from '@acorn-portal/shared/src/pages/misc/ChangePassword';
import ErrorPage from '@acorn-portal/shared/src/pages/misc/ErrorPage';
import LogOutPage from '@acorn-portal/shared/src/pages/misc/LogOut';
import PortalHome from '@acorn-portal/shared/src/pages/misc/portal-home';
import ChangeOfAddress from '@acorn-portal/shared/src/pages/mta/change-of-address';
import ChangeOfMileage from '@acorn-portal/shared/src/pages/mta/change-of-mileage';
import ChangeOfUsageTaxi from '@acorn-portal/shared/src/pages/mta/change-of-usage-taxi';
import ChangeUsageOrMileage from '@acorn-portal/shared/src/pages/mta/change-usage-or-mileage';
import ChangeOfVehiclePart1 from '@acorn-portal/shared/src/pages/mta/ChangeOfVehiclePart1';
import ChangeOfVehiclePart2 from '@acorn-portal/shared/src/pages/mta/ChangeOfVehiclePart2';
import MakeAChangeHome from '@acorn-portal/shared/src/pages/mta/make-a-change-home';
import MtaSummaryScreen from '@acorn-portal/shared/src/pages/mta/MtaSummaryScreen';
import MtaPaymentOptions from '@acorn-portal/shared/src/pages/mta/payment-options';
import TopUpMiles from '@acorn-portal/shared/src/pages/mta/TopUpMiles';
import TopUpMilesDate from '@acorn-portal/shared/src/pages/mta/TopUpMilesDate';
import TopUpMilesPrice from '@acorn-portal/shared/src/pages/mta/TopUpMilesPrice';
import ChangeOfPaymentDate from '@acorn-portal/shared/src/pages/paymentManagement/change-of-payment-date';
import ChangeOfBankDetails from '@acorn-portal/shared/src/pages/paymentManagement/ChangeOfBankDetails';
import FullPaymentSchedule from '@acorn-portal/shared/src/pages/paymentManagement/FullPaymentSchedule';
import { AcornProtectPolicyRouter } from '@acorn-portal/shared/src/components/telematics/common';
import TripListPage from '@acorn-portal/shared/src/pages/telematics/trip-list';
import TripDetailsPage from '@acorn-portal/shared/src/pages/telematics/trip-details';
import Registration from '@acorn-portal/shared/src/pages/registration/Registration';
import ResendRegistration from '@acorn-portal/shared/src/pages/registration/ResendRegistration';
import ChangeOfAddressRenewal from '@acorn-portal/shared/src/pages/renewal/ChangeOfAddress';
import RenewalChangeOfUsageTaxi from '@acorn-portal/shared/src/pages/renewal/ChangeOfUsageTaxi';
import RenewalChangeOfVehiclePart1 from '@acorn-portal/shared/src/pages/renewal/ChangeOfVehiclePart1';
import RenewalChangeOfVehiclePart2 from '@acorn-portal/shared/src/pages/renewal/ChangeOfVehiclePart2';
import ChangeUsageOrMileageRenewals from '@acorn-portal/shared/src/pages/renewal/ChangeUsageOrMileage';
import MakePayment from '@acorn-portal/shared/src/pages/renewal/MakePayment';
import OptionalExtras from '@acorn-portal/shared/src/pages/renewal/optional-extras';
import PaymentOptions from '@acorn-portal/shared/src/pages/renewal/PaymentOptions';
import RenewalsList from '@acorn-portal/shared/src/pages/renewal/RenewalList';
import RenewalReferralPage from '@acorn-portal/shared/src/pages/renewal/RenewalReferral';
import RenewalSummaryScreen from '@acorn-portal/shared/src/pages/renewal/RenewalSummaryScreen';
// Specific pages
// Specific pages
import ManagedPaymentsError from '@acorn-portal/shared/src/components/copy/ManagedPaymentsError';
import MTAManageDrivers from '@acorn-portal/shared/src/pages/mta/mta-manage-drivers';
import ChangeBankError from '@acorn-portal/shared/src/pages/paymentManagement/pages/change-bank-error';
import RenewalManageDrivers from '@acorn-portal/shared/src/pages/renewal/renewal-manage-drivers';
import ChangeBankSuccess from '@acorn/portal/src/pages/mangedPayments/ChangeBankSuccess';
import NeedHelp from '@acorn/portal/src/pages/misc/NeedHelp';
import ServiceUnavailable from '@acorn/portal/src/pages/misc/ServiceUnavailable';
import ChangeSuccess from '@acorn/portal/src/pages/mta/ChangeSuccess';
import MtaReferralPage from '@acorn/portal/src/pages/mta/MtaReferral';
import PaymentSuccess from '@acorn/portal/src/pages/renewal/PaymentSuccess';
import Refer from '@acorn/portal/src/pages/renewal/Refer';

import MileageBasedPolicyRouter from '@acorn-portal/shared/src/components/wrapper/MileageBasedPolicyRouter';
import { BraintreeProvider } from '@acorn-portal/shared/src/context/braintree-context';

import StripePaymentFormWrapper from '@acorn-portal/shared/src/components/wrapper/stripe-checkout-wrapper';
import ChangePaymentDaySuccess from './pages/mangedPayments/ChangePaymentDaySuccess';
import PolicyProductGateway from '@acorn/portal/src/components/policy-product-gateway';
import PayNowGateway from '@acorn/portal/src/components/pay-now-gateway';
import PaymentGateway from '@acorn/portal/src/components/payment-gateway';
import RemoteRouteSwitch from '@acorn/portal/src/components/remote-route-switch';
import { LocalPayNowRoutes, LocalPaymentRoutes } from '@acorn/portal/src/components/local-pay-now-routes';

//Subscriptions
import SubscriptionRestart from './pages/subscription-restart';
import SubscriptionRestartAmendAddress from './pages/subscription-restart/amend-address';
import SubscriptionRestartAmendDrivers from './pages/subscription-restart/amend-drivers';
import SubscriptionRestartAmendUsage from './pages/subscription-restart/amend-usage';
import SubscriptionRestartAmendVehicle1 from './pages/subscription-restart/amend-vehicle/amend-vehicle-part-1';
import SubscriptionRestartAmendVehicle2 from './pages/subscription-restart/amend-vehicle/amend-vehicle-part-2';
import SubscriptionRestartPaymentOptions from './pages/subscription-restart/payment-options';
import SubscriptionRestartPaymentSuccess from './pages/subscription-restart/payment-success';
import SubscriptionRestartSummary from './pages/subscription-restart/summary';
import SubscriptionReferral from './pages/subscription-restart/referral';

// Cancellations
import CancellationLayout from '@acorn-portal/shared/src/pages/cancellation/layout';
import CancellationReason from '@acorn-portal/shared/src/pages/cancellation/cancellation-reason';
import CancellationDate from '@acorn-portal/shared/src/pages/cancellation/cancellation-date';
import CancellationConfirmation from '@acorn-portal/shared/src/pages/cancellation/cancellation-confirmation';
import CancellationSuccess from '@acorn-portal/shared/src/pages/cancellation/cancellation-success';

const Routes = () => {
	const routes: RouteObject[] = [
		{
			path: '/portal/',
			element: <AuthorizedLayout />,
			children: [
				{
					element: <PortalHome />,
				},
				{
					path: ROUTE_PATHS.logOut,
					element: <LogOutPage />,
				},
				{
					path: ROUTE_PATHS.home,
					element: <PortalHome />,
				},
				{
					path: `${ROUTE_PATHS.policyDetails}/:policyToken`,
					element: <AcornProtectPolicyRouter />,
				},
				{
					path: 'hh/*',
					element: <PolicyProductGateway />,
				},
				{
					path: ROUTE_PATHS.telematicsTrips,
					element: <TripListPage />,
				},
				{
					path: ROUTE_PATHS.telematicsTripDetails,
					element: <TripDetailsPage />,
				},
				{
					path: ROUTE_PATHS.help,
					element: <NeedHelp />,
				},
				{
					path: ROUTE_PATHS.changePassword,
					element: <ChangePassword />,
				},
				{
					path: ROUTE_PATHS.makeAChangeHome,
					element: <MakeAChangeHome />,
				},
				{
					path: ROUTE_PATHS.makeAChangeAddress,
					element: (
						<MTAStartDateCheck>
							<ChangeOfAddress />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeUsageAndMileage,
					element: (
						<MTAStartDateCheck>
							<ChangeUsageOrMileage />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeUsageTaxi,
					element: (
						<MTAStartDateCheck>
							<ChangeOfUsageTaxi />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeVehicle,
					element: (
						<MTAStartDateCheck>
							<ChangeOfVehiclePart1 />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeMileage,
					element: (
						<MTAStartDateCheck>
							<MileageBasedPolicyRouter
								mileageBasedComponent={<TopUpMiles />}
								standardComponent={<ChangeOfMileage />}
							/>
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeVehicle2,
					element: (
						<MTAStartDateCheck>
							<ChangeOfVehiclePart2 />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeDrivers,
					element: (
						<MTAStartDateCheck>
							<MTAManageDrivers />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeSummary,
					element: <MtaSummaryScreen />,
				},
				{
					path: ROUTE_PATHS.makeAChangeReferral,
					element: <MtaReferralPage />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeReferral,
					element: <RenewalReferralPage />,
				},
				{
					path: ROUTE_PATHS.makeAChangePaymentOptions,
					element: (
						<BraintreeProvider>
							<MtaPaymentOptions />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangePaymentSuccess,
					element: <ChangeSuccess />,
				},
				{
					path: ROUTE_PATHS.renewalCheckout,
					element: (
						<BraintreeProvider>
							<StripePaymentFormWrapper>
								<MakePayment />
							</StripePaymentFormWrapper>
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.policyRenewals,
					element: <RenewalsList />,
				},

				{
					path: ROUTE_PATHS.renewalMakeAChangeVehicle,
					element: <RenewalChangeOfVehiclePart1 />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeUsageTaxi,
					element: <RenewalChangeOfUsageTaxi />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeVehicle2,
					element: <RenewalChangeOfVehiclePart2 />,
				},
				{
					path: ROUTE_PATHS.renewalCheckoutSuccess,
					element: <PaymentSuccess />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeSummary,
					element: <RenewalSummaryScreen />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeUsageAndMileage,
					element: <ChangeUsageOrMileageRenewals />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeAddress,
					element: <ChangeOfAddressRenewal />,
				},
				{
					path: ROUTE_PATHS.renewalOptionalExtras,
					element: <OptionalExtras />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeDrivers,
					element: <RenewalManageDrivers />, //ManageDrivers serviceType="Renewal" />,
				},
				{
					path: `${ROUTE_PATHS.policyRenewals}/make-payment`,
					element: <MakePayment />,
				},
				{
					path: ROUTE_PATHS.policyRenewalRefer,
					element: <Refer />,
				},
				{
					path: `${ROUTE_PATHS.policyRenewals}/payment`,
					element: <PaymentOptions />,
				},
				{
					path: `${ROUTE_PATHS.makeAChangeMileage}`,
					element: <TopUpMiles />,
				},
				{
					path: `${ROUTE_PATHS.topUpMilesDate}`,
					element: <TopUpMilesDate />,
				},
				{
					path: ROUTE_PATHS.topUpMilesPrice,
					element: <TopUpMilesPrice />,
				},
				{
					path: ROUTE_PATHS.error,
					element: <ErrorPage />,
				},
				{
					path: `${ROUTE_PATHS.subscriptionRestart}/:policyToken`,
					element: <SubscriptionRestart />,
				},
				{
					path: `${ROUTE_PATHS.subscriptionRestartSummary}/:policyToken`,
					element: <SubscriptionRestartSummary />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartAmendVehicle1,
					element: <SubscriptionRestartAmendVehicle1 />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartAmendVehicle2,
					element: <SubscriptionRestartAmendVehicle2 />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartAmendAddress,
					element: <SubscriptionRestartAmendAddress />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartAmendDrivers,
					element: <SubscriptionRestartAmendDrivers />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartAmendUsage,
					element: <SubscriptionRestartAmendUsage />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartPaymentOptions,
					element: (
						<BraintreeProvider>
							<SubscriptionRestartPaymentOptions />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.subscriptionRestartPaymentSuccess,
					element: <SubscriptionRestartPaymentSuccess />,
				},
				{
					path: ROUTE_PATHS.subscriptionRestartReferral,
					element: <SubscriptionReferral />,
				},
				// Cancellations Journey
				{
					path: ROUTE_PATHS.cancellation,
					element: <CancellationLayout />,
					children: [
						{
							index: true,
							element: <Navigate to={ROUTE_PATHS.cancellationReason} replace />,
						},
						{
							path: ROUTE_PATHS.cancellationReason,
							element: <CancellationReason />,
						},
						{
							path: ROUTE_PATHS.cancellationDate,
							element: <CancellationDate />,
						},
						{
							path: ROUTE_PATHS.cancellationConfirmation,
							element: <CancellationConfirmation />,
						},
						{
							path: ROUTE_PATHS.cancellationSuccess,
							element: <CancellationSuccess />,
						},
					],
				},
			],
		},
		{
			path: '/pay-now/',
			element: <AuthorizedLayout />,
			children: [
				{
					// Strangler-fig swap: PostHog flag picks the paynowRemote plugin or the
					// existing local pages (in LocalPayNowRoutes). Flag off = today's behaviour.
					path: '/pay-now/*',
					element: (
						<RemoteRouteSwitch
							flag='paynow-remote-enabled'
							force={import.meta.env.VITE_PAYNOW_REMOTE_FORCE === 'true'}
							remote={<PayNowGateway />}
							local={<LocalPayNowRoutes />}
						/>
					),
				},
			],
		},
		{
			path: '/payment-management/',
			element: <AuthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.fullPaymentSchedule,
					element: <FullPaymentSchedule />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangeBankDetails,
					element: <ChangeOfBankDetails />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangePaymentDate,
					element: <ChangeOfPaymentDate />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangePaymentDateSuccess,
					element: <ChangePaymentDaySuccess />,
				},

				{
					path: ROUTE_PATHS.changeBankSuccess,
					element: <ChangeBankSuccess />,
				},
				{
					path: ROUTE_PATHS.changeBankError,
					element: (
						<ChangeBankError>
							<ManagedPaymentsError company='ACORN' errorType='changeBankError' />
						</ChangeBankError>
					),
				},
			],
		},
		{
			path: '/account/',
			element: <UnauthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.register,
					element: <Registration />,
				},
				{
					path: ROUTE_PATHS.resendRegistration,
					element: <ResendRegistration />,
				},
			],
		},
		{
			path: '/payment/',
			element: <UnauthorizedLayout />,
			children: [
				{
					// Anonymous token-link family — same flag-gated swap, separate flag so it
					// can roll out (and roll back) independently of /pay-now/*.
					path: '/payment/*',
					element: (
						<RemoteRouteSwitch
							flag='payment-remote-enabled'
							force={import.meta.env.VITE_PAYMENT_REMOTE_FORCE === 'true'}
							remote={<PaymentGateway />}
							local={<LocalPaymentRoutes />}
						/>
					),
				},
			],
		},
		{
			path: '/outage/',
			element: <UnauthorizedLayout />,
			children: [
				{
					index: true,
					element: <ServiceUnavailable />,
				},
			],
		},
		{
			path: '/err/',
			element: <UnauthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.unauthorisedError,
					element: <ErrorPage />,
				},
			],
		},
		{
			path: '*',
			element: <Navigate to='/portal/home' replace />,
		},
	];
	return routes;
};

export default Routes;
